var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hero-section"},[_c('div',{staticClass:"hero-section-text"},[_c('h1',[_c('img',{attrs:{"src":"/images/icon_error.svg","alt":""}}),_c('br'),_vm._v("情報が見つかりません")])])]),_c('div',{staticClass:"site-description"},[_c('p',[_vm._v("お探しのページは削除されたか、名前が変更されたか、一時的に利用できない可能性があります。")])])])
}]

export { render, staticRenderFns }